// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__XyRO0","left":"StickyBox_left__3Gpa1","right":"StickyBox_right__3UNwK"};